// logout_dialog tasarımı: çıkış onay dialogu. Çıkış butonuyla gerçek çıkış
// arasına girer — "Çıkış Yap" eski çıkış akışını (onConfirm) aynen çalıştırır
// (API isteği/oda terk Flutter'daki exitGame köprüsünde), "İptal" ve karartmaya
// dokunma sadece kapatır. Lobi ve oyun içi aynı bileşeni kullanır.
import { createPortal } from 'react-dom';
import imgBg from '../../assets/exitdlg_bg.png';
import imgIcon from '../../assets/exitdlg_icon.png';
import imgTitle from '../../assets/exitdlg_title.png';
import imgSub from '../../assets/exitdlg_sub.png';
import imgIptal from '../../assets/exitdlg_btn_iptal.png';
import imgCikis from '../../assets/exitdlg_btn_cikis.png';

const CSS = `
#batakExitDlg{position:fixed;inset:0;z-index:10006;display:flex;align-items:center;justify-content:center;background:rgba(2,8,5,.78);padding:24px}
#batakExitDlg .dlg{position:relative;width:min(82vw,320px);aspect-ratio:907/849;background:url(${imgBg}) center / 100% 100% no-repeat;box-sizing:border-box;display:flex;flex-direction:column;align-items:center;padding:32% 9% 11%;animation:exitDlgIn .22s cubic-bezier(.34,1.4,.64,1) both}
@keyframes exitDlgIn{from{opacity:0;transform:scale(.88)}to{opacity:1;transform:scale(1)}}
#batakExitDlg .icon{position:absolute;top:11.5%;left:50%;transform:translateX(-50%);width:14.5%;height:auto}
#batakExitDlg .title{width:82%;height:auto;display:block}
#batakExitDlg .sub{width:74%;height:auto;display:block;margin-top:6.5%}
#batakExitDlg .row{display:flex;align-items:center;justify-content:center;gap:6%;margin-top:8.5%;width:100%}
#batakExitDlg .b{width:38%;padding:0;border:none;background:none;cursor:pointer;-webkit-tap-highlight-color:transparent}
#batakExitDlg .b img{width:100%;height:auto;display:block;filter:drop-shadow(0 3px 6px rgba(0,0,0,.45))}
#batakExitDlg .b:active{transform:scale(.94)}
`;

const ExitConfirmDialog = ({ open, onConfirm, onCancel }) => {
    if (!open) return null;
    return createPortal(
        <>
            <style>{CSS}</style>
            <div id="batakExitDlg" onClick={onCancel}>
                <div className="dlg" onClick={(e) => e.stopPropagation()}>
                    <img className="icon" src={imgIcon} alt="" draggable={false} />
                    <img className="title" src={imgTitle} alt="Oyundan çıkmak istediğinize emin misiniz?" draggable={false} />
                    <img className="sub" src={imgSub} alt="Çıkış yaparsanız mevcut oyundan ayrılacaksınız." draggable={false} />
                    <div className="row">
                        <button type="button" className="b" onClick={onCancel} aria-label="İptal">
                            <img src={imgIptal} alt="İptal" draggable={false} />
                        </button>
                        <button type="button" className="b" onClick={onConfirm} aria-label="Çıkış Yap">
                            <img src={imgCikis} alt="Çıkış Yap" draggable={false} />
                        </button>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default ExitConfirmDialog;
